import { LayoutComponent } from '../layout/layout.component';
import { LoginComponent } from './user/login/login.component';
import { AuthGuard } from '../services/auth-guard.service';
import { VirtualTerminalAccessComponent } from './user/virtual-terminal-access/virtual-terminal-access.component';

import { Routes } from '@angular/router';
//import { PayoutlayoutComponent } from '../routes/PayOut/PayOutHome/payoutlayout/payoutlayout.component';
import { FeaturesEnabledComponent } from './features-enabled/features-enabled/features-enabled.component';
import { PayoutlayoutComponent } from './PayOut/PayOutHome/payoutlayout/payoutlayout.component';
import { PoslayoutComponent } from '../POS/poslayout/poslayout.component';
import { NewLoginComponent } from './user/new-login/new-login.component';
import { NewOnboardingProcessComponent } from './registration/new-onboarding-process/new-onboarding-process.component';
import { NewForgotpasswordverificationComponent } from './registration/new-forgotpasswordverification/new-forgotpasswordverification.component';
import { NewOtpverificationComponent } from './registration/new-otpverification/new-otpverification.component';
import { RegisterNewuserComponent } from './user/register-newuser/register-newuser.component';
import { AcLayoutComponent } from '../accounting/layout/ac-layout/ac-layout.component';

export const routes: Routes = [
  {
    path: '',
    component: LayoutComponent,
    canActivate: [AuthGuard],
    children: [
      { path: '', redirectTo: 'home', pathMatch: 'full' },
      {
        path: 'home',
        canActivate: [AuthGuard],
        loadChildren: () =>
          import('./dashboard-new/dashboard-new.module').then(
            (m) => m.DashboardNewModule
          ),
        // import('./home/home.module').then((m) => m.HomeModule),
      },
      {
        path: 'home',
        canActivate: [AuthGuard],
        loadChildren: () =>
          import('./dashboard-new/dashboard-new.module').then(
            (m) => m.DashboardNewModule
          ),
        // import('./home/home.module').then((m) => m.HomeModule),
      },
      {
        path: 'dashboard',
        canActivate: [AuthGuard],
        loadChildren: () =>
          import('./dashboard/dashboard.module').then((m) => m.DashboardModule),
      },
      {
        path: 'dashboard-new',
        canActivate: [AuthGuard],
        loadChildren: () =>
          import('./dashboard-new/dashboard-new.module').then(
            (m) => m.DashboardNewModule
          ),
      },
      {
        path: 'transactions',
        canActivate: [AuthGuard],
        loadChildren: () =>
          import('./transaction/transaction.module').then(
            (m) => m.TransactionModule
          ),
      },
      {
        path: 'addonbusiness',
        canActivate: [AuthGuard],
        loadChildren: () =>
          import('./addonBusiness/addonbusiness.module').then(
            (m) => m.AddOnBusinessModule
          ),
      },
      {
        path: 'ecomsolutions',
        canActivate: [AuthGuard],
        loadChildren: () =>
          import('./ecomSolutions/ecomsolutions.module').then(
            (m) => m.EcomSolutionsModule
          ),
      },
      {
        path: 'futurebilling',
        canActivate: [AuthGuard],
        loadChildren: () =>
          import('./futureBilling/futurebilling.module').then(
            (m) => m.FutureBillingModule
          ),
      },
      {
        path: 'invoice',
        canActivate: [AuthGuard],
        loadChildren: () =>
          import('./invoice/invoice.module').then((m) => m.InvoiceModule),
      },
      {
        path: 'prepaidcards',
        canActivate: [AuthGuard],
        loadChildren: () =>
          import('./prepaidCards/prepaidcards.module').then(
            (m) => m.PrepaidCardsModule
          ),
      },
      {
        path: 'securevault',
        canActivate: [AuthGuard],
        loadChildren: () =>
          import('./secureVault/securevault.module').then(
            (m) => m.SecureVaultModule
          ),
      },
      {
        path: 'reports',
        canActivate: [AuthGuard],
        loadChildren: () =>
          import('./reports/reports.module').then((m) => m.ReportsModule),
      },
      // { path: 'user', loadChildren: () => import('./user/user.module').then(m => m.UserModule) },
      {
        path: 'fileprocessing',
        canActivate: [AuthGuard],
        loadChildren: () =>
          import('./fileProcessing/fileprocessing.module').then(
            (m) => m.FileProcessingModule
          ),
      },
      {
        path: 'settings',
        canActivate: [AuthGuard],
        loadChildren: () =>
          import('./settings/setting.module').then((m) => m.TransactionModule),
      },

      {
        path: 'agreements',
        // canActivate: [AuthGuard],
        loadChildren: () =>
          import('./esign-agreements/esign-agreements.module').then(
            (m) => m.EsignAgreementsModule
          ),
      },

      {
        path: 'settlementvendors',
        canActivate: [AuthGuard],
        loadChildren: () =>
          import('./settlementvendors/settlementvendors.module').then(
            (m) => m.SettlementvendorsModule
          ),
      },
      {
        path: 'Coupon',
        loadChildren: () =>
          import('./Coupons/coupon.module').then((m) => m.CouponModule),
      },
      {
        path: 'Cart',
        loadChildren: () =>
          import('./Cart/cartdetail.module').then((m) => m.CartdetailModule),
      },
      //{ path: 'PayOut', loadChildren: () => import('./PayOut/payoutmodule.module').then(m => m.PayModule) },
      {
        path: 'Ticket',
        loadChildren: () =>
          import('./SupportTicket/ticket.module').then((m) => m.TicketModule),
      },
      {
        path: 'PayProfile',
        loadChildren: () =>
          import('./PayProfile/profile.module').then((m) => m.ProfileModule),
      },
      {
        path: 'featuresEnabled',
        loadChildren: () =>
          import('./features-enabled/features-enabled.module').then(
            (m) => m.FeaturesEnabledModule
          ),
      },
      {
        path: 'BookingTicket',
        loadChildren: () =>
          import('./BookingTicket/booking-ticket.module').then(
            (m) => m.BookingTicketModule
          ),
      },
      // //pos routes
      {
        path: 'booking-dashboard',
        loadChildren: () =>
          import('./booking-dashboard/booking-dashboard.module').then(
            (m) => m.BookingDashboardModule
          ),
      },
      {
        path: 'PayProfile',
        loadChildren: () =>
          import('./PayProfile/profile.module').then((m) => m.ProfileModule),
      },
      {
        path: 'AB',
        loadChildren: () =>
          import('./bidding/bidding.module').then((m) => m.BiddingModule),
      },
      {
        path: 'bidding',
        loadChildren: () =>
          import('./bidding/bidding.module').then((m) => m.BiddingModule),
      },
      {
        path: 'pay-profile',
        loadChildren: () =>
          import('./PayProfile/analytics/analytics.module').then(
            (m) => m.AnalyticsModule
          ),
      },
    ],
  },
  {
    path: 'pos',
    component: PoslayoutComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        loadChildren: () =>
          import('../POS/pos.module').then((m) => m.POSModule),
      },
    ],
  },

  {
    path: 'accounting',
    component: AcLayoutComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        loadChildren: () =>
          import('../accounting/accounting.module').then(
            (m) => m.AccountingModule
          ),
      },
    ],
  },
  {
    path: 'onboarding',
    loadChildren: () =>
      import('./onboarding/onboarding.module').then((m) => m.OnboardingModule),
  },
  {
    path: 'new-payments',
    loadChildren: () =>
      import('./new-payment-process/new-payment-process.module').then(
        (m) => m.NewPaymentProcessModule
      ),
  },
  {
    path: 'PayOut',
    component: PayoutlayoutComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        loadChildren: () =>
          import('./PayOut/payoutmodule.module').then((m) => m.PayModule),
      },
    ],
  },
  //     // Not lazy-loaded routes
  { path: 'login', component: NewLoginComponent },
  { path: 'logins', component: NewLoginComponent },
  { path: 'newlogin', component: NewLoginComponent },
  { path: 'signup-onboard', component: NewOnboardingProcessComponent },
  { path: 'us/en/login', component: LoginComponent },
  { path: 'in/en/login', component: LoginComponent },
  { path: 'in/te/login', component: LoginComponent },
  { path: 'in/hi/login', component: LoginComponent },
  {
    path: 'supportloginauthenication',
    component: VirtualTerminalAccessComponent,
  },

  {
    path: 'registration',
    loadChildren: () =>
      import('./registration/registration.module').then(
        (m) => m.RegistrationModule
      ),
  },
  {
    path: 'us/en/registration',
    loadChildren: () =>
      import('./registration/registration.module').then(
        (m) => m.RegistrationModule
      ),
  },
  {
    path: 'in/en/registration',
    loadChildren: () =>
      import('./registration/registration.module').then(
        (m) => m.RegistrationModule
      ),
  },
  {
    path: 'in/te/registration',
    loadChildren: () =>
      import('./registration/registration.module').then(
        (m) => m.RegistrationModule
      ),
  },
  {
    path: 'in/hi/registration',
    loadChildren: () =>
      import('./registration/registration.module').then(
        (m) => m.RegistrationModule
      ),
  },
  {
    path: 'bidding-module',
    loadChildren: () =>
      import('./bidding/bidding.module').then((m) => m.BiddingModule),
  },
  {
    path: 'pay-profile',
    canActivate: [AuthGuard],
    children: [
      {
        path: 'create-new/smart-collect',
        loadChildren: () =>
          import('./PayProfile/create-new/create-new.module').then(
            (m) => m.CreateNewModule
          ),
        data: {
          mode: 'smart-collect',
        },
      },
      {
        path: 'create-new/easy-collect',
        loadChildren: () =>
          import('./PayProfile/create-new/create-new.module').then(
            (m) => m.CreateNewModule
          ),
        data: {
          mode: 'easy-collect',
          inEditMode: false,
        },
      },
      {
        path: 'edit-profile/easy-collect/:id',
        loadChildren: () =>
          import('./PayProfile/create-new/create-new.module').then(
            (m) => m.CreateNewModule
          ),
        data: {
          mode: 'easy-collect',
          inEditMode: true,
        },
      },
      {
        path: 'edit-profile/smart-collect/:id',
        loadChildren: () =>
          import('./PayProfile/create-new/create-new.module').then(
            (m) => m.CreateNewModule
          ),
        data: {
          mode: 'smart-collect',
          inEditMode: true,
        },
      },
      {
        path: 'create-new/smart-collect/:payProfileId',
        loadChildren: () =>
          import('./PayProfile/create-new/create-new.module').then(
            (m) => m.CreateNewModule
          ),
        data: {
          mode: 'smart-collect',
          inEditMode: false,
          inAddDataMode: true,
        },
      },
      {
        path: 'payment-receipt-settings/:payProfileId',
        loadChildren: () =>
          import(
            './PayProfile/payment-receipt-settings/payment-receipt-settings.module'
          ).then((m) => m.PaymentReceiptSettingsModule),
      },
      {
        path: 'pay-profile-settings/:payProfileId',
        loadChildren: () =>
          import(
            './PayProfile/pay-profile-settings/pay-profile-settings.module'
          ).then((m) => m.PayProfileSettingsModule),
      },
      {
        path: 'user-data/:payProfileId',
        loadChildren: () =>
          import('./PayProfile/user-data/user-data.module').then(
            (m) => m.UserDataModule
          ),
      },
      {
        path: 'recent-booking-profile',
        loadChildren: () =>
          import(
            './PayProfile/recent-booking-profile/recent-booking-profile.module'
          ).then((m) => m.RecentBookingProfileModule),
      },
    ],
  },

  {
    path: 'dummy-api-login',
    loadChildren: () =>
      import('./dummy-api-login/dummy-api-login.module').then(
        (m) => m.DummyApiLoginModule
      ),
  },

  {
    path: 'test-component',
    loadChildren: () =>
      import('./test-module/test-module.module').then(
        (m) => m.TestModuleModule
      ),
  },

  //  { path: 'user', loadChildren: () => import('./user/user.module').then(m => m.UserModule) },
  //  { path: 'us/en/user', loadChildren: () => import('./user/user.module').then(m => m.UserModule) },
  //  { path: 'in/en/user', loadChildren: () => import('./user/user.module').then(m => m.UserModule) },
  //  { path: 'in/te/user', loadChildren: () => import('./user/user.module').then(m => m.UserModule) },
  //  { path: 'in/hi/user', loadChildren: () => import('./user/user.module').then(m => m.UserModule) },
  { path: '**', redirectTo: 'home' },
];
